module.exports = __webpack_public_path__ + "img/var_02_control.5871d5f3.png";